import { get } from '../utils/fetch';
import { MODE_PARTNER_API_ERROR } from '../defines/mode';

export const PartnerApi = {
  getPartnerBasicInfo: async (
    serviceId: number,
    serviceAttribute: number,
    partnerId: string,
  ): Promise<PartnerBasicInfo> => {
    const url = `/api/partners/${serviceId}/${serviceAttribute}/${partnerId}`;

    // for quick test, secret 'mode' parameter is checked. when mode is expected, then it raises Exception
    // nobody knows this parameter!
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.get('mode') === MODE_PARTNER_API_ERROR) {
      throw new Error();
    }
    return await get(url, 'getPartnerBasicInfo');
  },
};

// TODO: samp implementation in rmp-bff -> move to rmp-modules
// for travel, partner means hotel
export interface PartnerBasicInfo {
  // for travel, it's hotel ID
  code: number;
  providerId: string;
  name: string;
  kanaName: string;
  imageUrl: string;
  telephone: string;
  isActive: Record<number, boolean>;
}
